import { router } from '@/router';
import { setStore, getStore, removeStore } from '@/lib/localStore';

/** @deprecated /v2 已废弃，统一使用首页 */
export const handleVersion = () => '/';

export const getVersion = () => {
  return getStore({
    name: 'HOME_VERSION',
  });
};

/** 清除旧版 v2 偏好，避免路由守卫循环跳转 */
export const migrateHomeVersion = () => {
  if (getStore({ name: 'HOME_VERSION' }) === 'v2') {
    removeStore({ name: 'HOME_VERSION' });
  }
};

export const gotoNew = () => {
  setStore({
    name: 'HOME_VERSION',
    content: '/',
  });
  router.replace('/');
};

export const gotoOld = () => {
  removeStore({ name: 'HOME_VERSION' });
  router.replace('/');
};
